// SPDX-License-Identifier: AGPL-3.0-or-later

import {type RefObject, useEffect} from 'react';

// A picker that closes with the focus inside it (or lost to the page, its button gone) hands the focus back to the
// room canvas, where the room's keys work; a focus the user moved elsewhere stays there.
export function useFocusBackOnClose(
	open: boolean,
	ref: RefObject<HTMLElement | null>,
	canvas: HTMLCanvasElement | null,
): void {
	useEffect(() => {
		if (!open) return;
		const doc = ref.current?.ownerDocument ?? document;
		return () => {
			const active = doc.activeElement;
			if (canvas && (active === null || active === doc.body || ref.current?.contains(active)))
				canvas.focus({preventScroll: true});
		};
	}, [open, ref, canvas]);
}
